import React, { useState } from 'react';

import {
  offset,
  OffsetOptions,
  useDismiss,
  useFloating,
  useInteractions
} from '@floating-ui/react';
import { STATIC_CLOSE_BUTTON_CLASS } from 'utils/components/modal';
import { STATIC_CONFIRMATION_MODAL_CLASS } from '../../sharable/components/modals/ConfirmationModal';

interface UseInputFloatingProps {
  offsetConfiguration: OffsetOptions;
}

export const useInputFloating = ({ offsetConfiguration }: UseInputFloatingProps) => {
  const [suggestionsIsOpen, setSuggestionsIsOpen] = useState(false);
  const { refs, floatingStyles, context } = useFloating({
    open: suggestionsIsOpen,
    onOpenChange: setSuggestionsIsOpen,
    placement: 'bottom-start',
    middleware: [offset(offsetConfiguration)]
  });

  const dismiss = useDismiss(context, {
    bubbles: { escapeKey: true },
    outsidePress: ({ target }) => {
      if (target instanceof Element) {
        const modal = target.closest(`.${STATIC_CONFIRMATION_MODAL_CLASS}`);
        const closeButton = target.closest(`.${STATIC_CLOSE_BUTTON_CLASS}`);

        return !modal && !closeButton;
      }

      return true;
    }
  });

  const { getReferenceProps, getFloatingProps } = useInteractions([dismiss]);

  return {
    refs,
    floatingStyles,
    getReferenceProps,
    getFloatingProps,
    suggestionsIsOpen,
    setSuggestionsIsOpen
  };
};
